import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit, faCheck } from "@fortawesome/free-solid-svg-icons";

function ProductListingVariations(props) {
  
  const [variants, setVariants] = useState([]);
  const [editingRows, setEditingRows] = useState({});

  useEffect(() => {
    if (props.listingData) {
      if (props.listingData.variants && props.listingData.variants.length > 0) {
        setVariants(props.listingData.variants);
      } 
      else if (props.listingData.formData && props.listingData.formData.sku) {
        const formData = props.listingData.formData;
        const skuArray = String(formData.sku).split(",").map(s => s.trim());
        
        const formattedVariants = skuArray.map(singleSku => ({
          sku: singleSku,
          size: formData.size || "",
          color: formData.color || ""
        }));
        
        setVariants(formattedVariants);
      } 
      else {
        setVariants([{ sku: "", size: "", color: "" }]);
        setEditingRows({ 0: true }); 
      }
    }
  }, [props.listingData]);

  const COLOR_OPTIONS = [
    "Black", "White", "Grey", "Silver", "Gold",
    "Red", "Blue", "Navy Blue", "Sky Blue",
    "Green", "Dark Green", "Olive Green",
    "Yellow", "Mustard Yellow",
    "Pink", "Hot Pink",
    "Purple", "Lavender","Orange",
    "Brown", "Dark Brown", "Light Brown",
    "Beige", "Cream", "Ivory",
    "Multicolor", "Transparent"
  ];

  const ALL_SIZES = [
    "4 × 6 in", "5 × 7 in", "6 × 8 in",
    "8 × 10 in", "10 × 12 in", "12 × 16 in",
    "16 × 20 in", "18 × 24 in", "20 × 30 in", "24 × 36 in",
    "8 × 8 in", "10 × 10 in", "12 × 12 in",
    "16 × 16 in", "20 × 20 in",
    "24 in", "27 in", "32 in", "40 in", "43 in",
    "50 in", "55 in", "65 in", "75 in", "85 in","10 × 10 × 4 in",
    "12 × 10 × 4 in","15 × 12 × 6 in","20 × 15 × 8 in","24 × 18 × 10 in",
    "12 × 18 in", "16 × 24 in", "20 × 24 in",
    "30 × 40 in", "36 × 48 in",
    "10 × 15 cm", "13 × 18 cm", "15 × 20 cm",
    "20 × 25 cm", "30 × 40 cm",
    "1 m", "2 m", "3 m", "5 m",
  ];

  const handleChange = (index, field, value) => {
    const updatedVariants = [...variants];
    updatedVariants[index][field] = value;
    setVariants(updatedVariants);
  };

  const toggleEditRow = (index) => {
    setEditingRows(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const addVariant = () => {
    const newIndex = variants.length;
    setVariants([...variants, { sku: "", size: "", color: "" }]);
    setEditingRows(prev => ({ ...prev, [newIndex]: true }));
  };

  const removeVariant = (index) => {
    setVariants(variants.filter((_, i) => i !== index));
    const updatedEditing = { ...editingRows };
    delete updatedEditing[index];
    setEditingRows(updatedEditing);
  };

  const handleNext = () => {
    props.setListingData(prev => ({
      ...prev,
      variants: variants
    }));

    props.nextStep();
  };

  return (
    <Container>
      <Row>
        <Col md={12} className="mt-2 mb-2">
          <h4>Step 6 : Product Variations</h4>
        </Col>

        <Col md={12}>
          <Card className="p-4">
            <Row className="mb-3">
              <Col md={12}>
                <h5><b>Manage Variants</b></h5>
              </Col>
            </Row>

            <Row className="mb-2 amazon-listing-labels">
              <Col md={3}>SKU</Col>
              <Col md={3}>Size</Col>
              <Col md={3}>Color</Col>
              <Col md={3}>Action</Col>
            </Row>

            {variants.map((variant, index) => {
              const isEditing = editingRows[index];

              return (
                <Row className="mb-2" key={index}>
                  
                  <Col md={3}>
                    <Input
                      type="text"
                      value={variant.sku}
                      onChange={(e) => handleChange(index, "sku", e.target.value)}
                    />
                  </Col>

                  <Col md={3}>
                    {isEditing ? (
                      <Input 
                        type="select" 
                        value={variant.size} 
                        onChange={(e) => handleChange(index, "size", e.target.value)}
                      >
                        <option value="">{variant.size || "Select Size"}</option>
                        {ALL_SIZES.map(s => <option key={s} value={s}>{s}</option>)}
                      </Input>
                    ) : (
                      <Input 
                        type="text" 
                        value={variant.size || "N/A"} 
                        readOnly 
                        style={{ backgroundColor: "#f8f9fa" }}
                      />
                    )}
                  </Col>

                  <Col md={3}>
                    {isEditing ? (
                      <Input 
                        type="select" 
                        value={variant.color}
                        onChange={(e) => handleChange(index, "color", e.target.value)}
                      >
                        <option value="">{variant.color || "Select Color"}</option>
                        {COLOR_OPTIONS.map(c => <option key={c} value={c}>{c}</option>)}
                      </Input>
                    ) : (
                      <Input 
                        type="text" 
                        value={variant.color || "N/A"} 
                        readOnly 
                        style={{ backgroundColor: "#f8f9fa" }}
                      />
                    )}
                  </Col>

                  {/* Actions Column */}
                  <Col md={3} className="d-flex align-items-center mt-1" style={{ gap: "15px" }}>
                    <div 
                      onClick={() => toggleEditRow(index)} 
                      title={isEditing ? "Save" : "Edit"}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isEditing ? faCheck : faEdit}
                        className={isEditing ? 'text-success' : 'text-primary'}
                        style={{ fontSize: "18px" }}
                      />
                    </div>
                    
                    <div 
                      onClick={() => removeVariant(index)}
                      title="Delete"
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon 
                        icon={faTrash} 
                        className="text-danger"
                        style={{ fontSize: "18px" }}
                      />
                    </div>
                  </Col>
                </Row>
              );
            })}

            <Row className="mt-3">
              <Col md={12}>
                <button className="btn btn-secondary" onClick={addVariant}>+ Add Variant</button>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>← Back</button>
          <button className="btn btn-primary" onClick={handleNext}>Next →</button>
        </Col>
      </Row>
    </Container>
  );
}

const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
  }
}

export default connect(mapStateToProps)(ProductListingVariations);